import React from "react";

function IconBathtub(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3 5.4a3.9 3.9 0 0 1 7.8 0v6.9h.3c1.16 0 2.1.94 2.1 2.1v3a5.1 5.1 0 0 1-5.1 5.1h-9a6.9 6.9 0 0 1-6.9-6.9v-1.2c0-1.16.94-2.1 2.1-2.1h14.7V5.4a2.1 2.1 0 1 0-4.2 0v.713c1.553.4 2.7 1.81 2.7 3.487H9.6a3.602 3.602 0 0 1 2.7-3.487V5.4Zm-8.7 8.7h16.8a.3.3 0 0 1 .3.3v3a3.3 3.3 0 0 1-3.3 3.3h-9a5.1 5.1 0 0 1-5.1-5.1v-1.2a.3.3 0 0 1 .3-.3Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconBathtub;
